import { render } from "./ImageViewer.vue?vue&type=template&id=f7764b34&scoped=true&ts=true"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=f7764b34&scoped=true&lang=scss"

import exportComponent from "/builds/saatsazov/saatsazov-com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7764b34"]])

export default __exports__